import React, { useState, useEffect } from 'react';

export const PersonalVideo = ({ videoId }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const hasVideo = !!videoId;
    if (!hasVideo) return null;   // <-- here

  return (
    <section id="video-intro" style={{ ...sectionStyle, padding: isMobile ? '40px 8%' : '80px 8%' }}>
      <div style={containerStyle}>
        
        {/* Boutique Nudge */}
        <p style={nudgeStyle}>CIAO! mi chiamo Francesca...</p>
        
        <div style={videoWrapper}>
          <div style={videoInner}>
          {hasVideo ? (
            <iframe
              src={`https://player.vimeo.com/video/${videoId}?h=835339f727&color=bc6c25&title=0&byline=0&portrait=0`}
              style={iframeStyle}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="Ciao! I'm Francesca"
            ></iframe>
          ) : (
            /* Placeholder for when video is missing */
            <div style={placeholderContent}>
            <div style={{ width: '80px', height: '80px', borderRadius: '50%', backgroundColor: 'rgba(188,108,37,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="8" r="4" fill="#BC6C25" opacity="0.5"/>
                    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" fill="#BC6C25" opacity="0.5"/>
                  </svg>
                </div>
                <p style={{ margin: 0, fontSize: '0.75rem', fontWeight: 700, color: '#BC6C25', textTransform: 'uppercase', letterSpacing: '2px', textAlign: 'center' }}>
              Video coming soon
            </p>
          </div>
          )}
        </div>
      </div>
      </div>
    </section>
  );
};

// --- Boutique Styling ---

const placeholderContent = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#F7F4EF',
  borderRadius: '10px',
  gap: '12px',
  zIndex: 2
};



// --- Your Existing Styles ---
const sectionStyle = { padding: '80px 8%', backgroundColor: '#FDF5E6', textAlign: 'center' };
const containerStyle = { maxWidth: '900px', margin: '0 auto' };
const nudgeStyle = { fontFamily: "'Montserrat', sans-serif", fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '4px', color: '#BC6C25', marginBottom: '30px', fontWeight: '500' };
const videoWrapper = { position: 'relative', width: '100%', marginBottom: '40px', boxShadow: '0 15px 35px rgba(40, 54, 24, 0.05)', borderRadius: '15px', overflow: 'hidden', backgroundColor: '#F7F4EF', padding: '8px', border: '1px solid rgba(188, 108, 37, 0.08)', boxSizing: 'border-box' };
const videoInner = { position: 'relative', width: '100%', paddingBottom: '56.25%', borderRadius: '10px', overflow: 'hidden' };
const iframeStyle = { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 2 };